// 通用内容
import request from '@/utils/request'
// 列表
export function list(data) {
  return request({
    url: '/admin/setting/webGlobalText/list',
    method: 'post',
    data
  })
}
// 添加
export function add(data) {
  return request({
    url: '/admin/setting/webGlobalText/add',
    method: 'post',
    data
  })
}

// 编辑
export function edit(data) {
  return request({
    url: '/admin/setting/webGlobalText/edit',
    method: 'post',
    data
  })
}
// 删除
export function remove(data) {
  return request({
    url: '/admin/setting/webGlobalText/remove',
    method: 'post',
    data
  })
}
